import { Component, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { StatementService } from '../../core/services/statement.service';
import { StatementResponse } from '../../core/models/statement-response';

@Component({
  selector: 'app-statements-list',
  standalone: true,
  imports: [CommonModule, RouterModule, DatePipe],
  templateUrl: './statements-list.component.html',
  styleUrls: ['./statements-list.component.css'],
})
export class StatementsListComponent implements OnInit {
  statements: StatementResponse[] = [];
  isLoading = true;
  errorMessage = '';

  constructor(private statementService: StatementService) {}

  ngOnInit(): void {
    this.loadStatements();
  }

  loadStatements(): void {
    this.isLoading = true;
    this.errorMessage = '';

    this.statementService.listStatements().subscribe({
      next: statements => {
        this.statements = statements;
        this.isLoading = false;
      },
      error: error => {
        console.log('Statements list error:', error);
        this.errorMessage =
          error?.error?.message ??
          error?.message ??
          'Failed to load statements.';
        this.isLoading = false;
      },
    });
  }
}
